var _path, _path2, _rect, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadVideoColorFinder = function SvgUploadVideoColorFinder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    d: "M25.058 20.863H1.369a.87.87 0 0 1-.869-.869V2.404c0-.48.39-.869.869-.869h23.689c.48 0 .869.39.869.87v17.589c0 .48-.39.869-.87.869Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "M9.646 15.068V7.279a.5.5 0 0 1 .728-.445l7.16 3.65a.5.5 0 0 1 .023.88l-7.16 4.137a.5.5 0 0 1-.75-.433Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.864,
    height: 10.864,
    x: 16.635,
    y: 15.535,
    fill: "#fff",
    rx: 5.432
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.864,
    height: 10.864,
    x: 16.635,
    y: 15.535,
    stroke: "#000",
    rx: 5.432
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "m22.062 23.58.003-5.29m0 0a.11.11 0 0 0-.079.029l-2.503 2.518m2.582-2.548q.036 0 .063.03l2.503 2.518"
  })));
};
export default SvgUploadVideoColorFinder;